import React, { useState } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { adminApi as api } from "../../../../util/api";
import { snakifyKeys } from "../../../../util/helpers";
import { StatusMappingForm, clearSubstatusMutator } from "./StatusMappingForm";

export const CreateStatusMappingModal = ({ onCreate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleCreate = async (values) => {
    setError(null);

    try {
      const res = await api.post("/admin/status_mappings", snakifyKeys({ statusMapping: values }));

      if (onCreate) {
        onCreate(res.data.resources);
      }

      setOpen(false);
    } catch (err) {
      setError(err);
    }
  };

  const formValidation = (values) => {
    const errors = {};

    if (values["allLabs"] && values["payorId"] && !values.cptCodeIds) {
      return {};
    } else if ((values["payorId"] || values["allPayors"] || values["allLabs"]) && !values.cptCodeIds && !values.labId) {
      errors.cptCodeIds = "CPT Code is required";
    }

    return errors;
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add Mapping
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add Status Mapping</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate} validate={formValidation} mutators={{ clearSubstatusMutator }}>
            {(props) => <StatusMappingForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
